import { render, staticRenderFns } from "./ResearchArchive.vue?vue&type=template&id=766b0d17"
import script from "./ResearchArchive.vue?vue&type=script&lang=js"
export * from "./ResearchArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('766b0d17')) {
      api.createRecord('766b0d17', component.options)
    } else {
      api.reload('766b0d17', component.options)
    }
    module.hot.accept("./ResearchArchive.vue?vue&type=template&id=766b0d17", function () {
      api.rerender('766b0d17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/research/ResearchArchive.vue"
export default component.exports